// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__Dz6Eu","spin":"Loader_spin__G43vI","hidden":"Loader_hidden__e3Bxt","disabled":"Loader_disabled__OiHn+"};